import React from 'react';
import Map from './Map';
import SingleMap from './SingleMap';
import Calendar from './Calendar';
import GridMap from './GridMap';
import Complete from './Complete';

import queryString from 'query-string';

let lightcss = <style>{`
    #bg{
        fill:white;
    }

    .roads {
        fill: none;
        stroke:#222;
        stroke-width: 1;
        opacity: 1;
    }

    .buildings {
        fill: #444;
        opacity: 1;
        stroke: #444;
    }

    .landuse {
        fill: transparent;
        opacity: 1;
        stroke: #CCC;
    }

    .water {
        opacity: 1;
        fill:#EEE;
        stroke: #444;
    }

    .waterway {
        opacity: 1;
        fill:none;
        stroke: #444;
    }

    #textRect {
        opacity: 0.95;
        fill:#FFF;
        stroke-width:0;
    }

    #title {
        fill: #000;
        font-size: 20px;
    }

    #subtitle {
        fill: #000;
        font-size: 12px;
    }

    .label {
        font-size: 7px;
        fill: #000;
    }

    .text {
        fill: #000;
    }

    .day {
        fill: #444;
        stroke: #fff;
    }

    .axis line {
        stroke: #000;
    }

    .axis path {
        stroke: #000;
    }

    .axis text {
        fill: #000;
    }
`}</style>;

let darkcss = <style>{`
    #bg{
        fill:#444;
    }

    .roads {
        fill: none;
        stroke:#CCC;
        stroke-width: 1;
        opacity: 1;
    }

    .buildings {
        fill: #222;
        opacity: 1;
        stroke: #222;
    }

    .landuse {
        fill: transparent;
        opacity: 1;
        stroke: #CCC;
    }

    .water {
        opacity: 1;
        fill:#888;
        stroke: #222;
    }

    .waterway {
        opacity: 1;
        fill:none;
        stroke: #222;
    }

    #textRect {
        opacity: 0.7;
        fill:#000;
        stroke-width:0;
    }

    #title {
        fill: #FFF;
        font-size: 20px;
    }

    #subtitle {
        fill: #FFF;
        font-size: 12px;
    }

    .label {
        font-size: 7px;
        fill: #FFF;
    }

    .text {
        fill: #FFF;
    }

    .day {
        fill: #CCC;
        stroke: #444;
    }


    .axis line {
        stroke: #FFF;
    }

    .axis path {
        stroke: #FFF;
    }

    .axis text {
        fill: #FFF;
    }
`}</style>;



class Poster extends React.Component {


    componentDidMount(prevProps, prevState, snapshot){
        const parsed = queryString.parse(window.location.search);
		if (typeof parsed.orderId !== 'undefined' & parsed.mode==='fs'){

				this.props.onFetchFullConfig(parsed.orderId,parsed.posterId);
		}
    }
    
    render() {

        var dist = this.props.poster.labels.calculatedDistance;
        if (this.props.poster.unit === 'mi') {
            dist = (this.props.poster.labels.calculatedDistance * 0.621371).toFixed(1)
        }
        var distance = dist + this.props.poster.unit;
        if (this.props.poster.labels.distance !== '') {
            distance = this.props.poster.labels.distance
        }

        var template = null;
        var footer = <g><rect id='textRect' x='0' y={this.props.poster.layout.height - this.props.poster.legend.height} width={this.props.poster.layout.width} height={this.props.poster.legend.height} />
            <rect x='0' y={this.props.poster.layout.height - this.props.poster.legend.height - this.props.poster.legend.spacer} width={this.props.poster.layout.width} height={this.props.poster.legend.spacer} fill='black' />
            <text id='title' x={this.props.poster.layout.width / 2} y={this.props.poster.layout.height - 53} textAnchor='middle'>
                {this.props.poster.labels.title}
            </text>
            <text id='subtitle' x={this.props.poster.layout.width / 2} y={this.props.poster.layout.height - 37} textAnchor='middle'>
                {this.props.poster.labels.subtitle}
            </text>
            <text className='label' x="20" y={this.props.poster.layout.height - 24} textAnchor='left'>
                ATHLETE
                        </text>
            <text className='text' id='athlete' x="20" y={this.props.poster.layout.height - 14} textAnchor='left'>
                {this.props.poster.labels.athlete}
            </text>
            <text className='label' x={this.props.poster.layout.width - 170} y={this.props.poster.layout.height - 24} textAnchor='left'>
                DISTANCE
                        </text>
            <text className='text' id='distance' x={this.props.poster.layout.width - 170} y={this.props.poster.layout.height - 14} textAnchor='left'>
                {distance}
            </text>
            <text className='label' x={this.props.poster.layout.width - 80} y={this.props.poster.layout.height - 24} textAnchor='left'>
                TIME
            </text>
            <text className='text' id='time' x={this.props.poster.layout.width - 80} y={this.props.poster.layout.height - 14} textAnchor='left'>
                {this.props.poster.labels.time}
            </text></g>

        switch (this.props.poster.template) {
            case "multiRoutesMap":
                template = <Map activities={this.props.poster.data} poster={this.props.poster} />
                break;
            case "singleRouteMap":
                template = <SingleMap activity={this.props.poster.data} poster={this.props.poster} />
                break;
            case "calendar":
                template = <Calendar activities={this.props.poster.data} poster={this.props.poster} />
                break;
            case "gridMap":
                template = <GridMap activities={this.props.poster.data} poster={this.props.poster} />
                break;
            case "complete":
                template = <Complete activity={this.props.poster.data} poster={this.props.poster} />
                footer = null;
                break;
            default:
        }

        let themecss = lightcss;
        if (this.props.poster.style.theme === 'dark') themecss = darkcss
        return (

            <div id='test'>
                <svg xmlns="http://www.w3.org/2000/svg" id='poster' width={this.props.poster.layout.width} height={this.props.poster.layout.height} fontFamily='Verdana' fontSize='10px' viewBox={"0 0 "+this.props.poster.layout.width+" "+this.props.poster.layout.height}>
                    {/*<link rel="stylesheet" type="text/css" href={"theme/" + this.props.poster.style.theme + ".css"} /> */}{/*Only used for Export. Work in Chrome but not with svgtoimg*/}
                    {themecss}
                    <rect id='bg' width="100%" height="100%" />
                    {template}

                    {footer}
                </svg>
            </div>

        )
    }
}

export default Poster;


// WEBPACK FOOTER //
// ./src/components/Poster.js